if (typeof window !== "undefined") {
    module.exports = window;
} else if (typeof global !== "undefined") {
    module.exports = global;
} else if (typeof self !== "undefined"){
    module.exports = self;
} else {
    module.exports = {};
}



//////////////////
// WEBPACK FOOTER
// ./~/global/window.js
// module id = 1424
// module chunks = 1